<script lang="ts">
	let { order = 1 } = $props<{ order?: 1 | -1 }>();
</script>

<img style="display:inline;" src={`/${order === 1 ? 'down' : 'up'}.svg`} alt="down" />
